import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getCookie } from '../../utils/cookies';
import '../../styles/global.css';

const LineLogin: React.FC = () => {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { loginLine, isAuthenticated, selectedLine } = useAuth();
  const navigate = useNavigate();

  // Redirect if already authenticated or if line is in context (from cookie/localStorage)
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
      return;
    }
    
    // Use selectedLine from context (which is loaded from cookie/localStorage in AuthContext)
    if (selectedLine && !isAuthenticated) {
      navigate('/login', { replace: true });
    }
  }, [isAuthenticated, navigate, selectedLine]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    
    // Validate before submitting
    if (!login || !login.trim()) {
      setError('Login linii jest wymagany');
      return;
    }
    if (!password || !password.trim()) {
      setError('Hasło linii jest wymagane');
      return;
    }
    
    setLoading(true);

    try {
      await loginLine(login.trim(), password);
      navigate('/login');
    } catch (err: any) {
      const errorMsg = err.response?.data?.message || 
                      err.response?.data?.errors?.login?.[0] || 
                      err.response?.data?.errors?.password?.[0] ||
                      'Nieprawidłowy login lub hasło linii produkcyjnej';
      setError(errorMsg);
      setPassword('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: '400px', margin: '50px auto', padding: '30px', background: 'white', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '30px', color: '#667eea' }}>🏭 Logowanie Linii Produkcyjnej</h2>
      
      {error && (
        <div style={{ 
          color: '#dc3545', 
          marginBottom: '15px', 
          padding: '12px', 
          backgroundColor: '#f8d7da', 
          borderRadius: '8px',
          border: '1px solid #f5c6cb'
        }}>
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', color: '#4a5568', fontWeight: '500' }}>
            Login linii:
          </label>
          <input
            type="text"
            value={login}
            onChange={(e) => setLogin(e.target.value)}
            required
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px',
              border: '2px solid #e1e8ed',
              borderRadius: '8px',
              fontSize: '16px',
              boxSizing: 'border-box',
              opacity: loading ? 0.6 : 1,
            }}
            autoFocus
          />
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', color: '#4a5568', fontWeight: '500' }}>
            Hasło linii:
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px',
              border: '2px solid #e1e8ed',
              borderRadius: '8px',
              fontSize: '16px',
              boxSizing: 'border-box',
              opacity: loading ? 0.6 : 1,
            }}
          />
        </div>

        <button
          type="submit"
          disabled={loading || !login || !password}
          style={{
            width: '100%',
            padding: '12px',
            backgroundColor: loading ? '#a0aec0' : '#667eea',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: loading || !login || !password ? 'not-allowed' : 'pointer',
            marginBottom: '15px',
          }}
        >
          {loading ? 'Logowanie...' : 'Zaloguj linię'}
        </button>
      </form>

      <div style={{ marginTop: '20px', paddingTop: '20px', borderTop: '2px solid #e1e8ed', textAlign: 'center' }}>
        <p style={{ color: '#718096', fontSize: '14px', marginBottom: '10px' }}>
          Jesteś administratorem?
        </p>
        <button
          onClick={() => navigate('/login')}
          style={{
            padding: '10px 20px',
            backgroundColor: '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px',
          }}
        >
          Zaloguj się jako administrator
        </button>
      </div>
    </div>
  );
};

export default LineLogin;
